import { gql } from "@apollo/client";

export const UPDATE_NEWS = gql`
  mutation updateAd($updateAdInput: UpdateAdInput!) {
    updateAd(updateAdInput: $updateAdInput) {
      id
    }
  }
`;
